import { useEffect, useState } from 'react';

import { Trans } from '@lingui/react/macro';
import Lottie from 'react-lottie';

// eslint-disable-next-line import/extensions
import aiLoadingAnimation from '../../../assets/images/ai-loading.json';

type LoadingAnimationProps = {
  isIconOnly?: boolean;
  translatedMessages?: JSX.Element[];
};

export const LoadingAnimation = ({
  isIconOnly = false,
  translatedMessages,
}: LoadingAnimationProps) => {
  const [messageIndex, setMessageIndex] = useState(0);

  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: aiLoadingAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    if (translatedMessages) {
      const interval = setInterval(() => {
        setMessageIndex(
          (currentIndex) => (currentIndex + 1) % translatedMessages.length,
        );
      }, 1500);

      return () => clearInterval(interval);
    }
  }, [translatedMessages]);

  return (
    <div className="vai-flex vai-flex-col vai-items-center vai-justify-center vai-h-full vai-w-full">
      <Lottie options={defaultLottieOptions} height={150} width={150} />
      {!isIconOnly && (
        <>
          <h1 className="vai-mt-4 vai-text-2xl vai-font-medium">
            {translatedMessages && translatedMessages[messageIndex]}
          </h1>
          <p className="vai-mt-2 vai-text-zinc-500" role="status">
            <Trans>This will only take a few seconds</Trans>
          </p>
        </>
      )}
    </div>
  );
};
